import { clsx as classnames, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Util class that merges classnames and applies tailwind merge to the resulting string to avoid style conflicts
 */
export function clsx(...inputs: ClassValue[]) {
    return twMerge(classnames(inputs));
}

export function cn(...inputs: ClassValue[]) {
    return twMerge(classnames(inputs));
}
